/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { LineMessageSendingQuotaFragmentDoc } from '../../components/organisms/LineMessageSendingQuota/LineMessageSendingQuota.generated';
export type DashboardPageLineMessageSendingQuotaSectionFragment = { lineMessagingCurrentMonthQuota: { totalUsage: number, quota:
      | { __typename: 'LineMessagingCurrentMonthQuota_Limited', limit: number }
      | { __typename: 'LineMessagingCurrentMonthQuota_None', void: any }
     } };

export const DashboardPageLineMessageSendingQuotaSectionFragmentDoc = gql`
    fragment DashboardPageLineMessageSendingQuotaSection on Query {
  ...LineMessageSendingQuota
}
    ${LineMessageSendingQuotaFragmentDoc}`;